import {TableHeader, TableRow} from "../../../components/table/CustomTable";


export default function AddFeatureTableHeader() {

  return (


    <thead>
    <TableRow>
      <TableHeader className="w-60">
        Feature
      </TableHeader>
      <TableHeader>
        Permissions
      </TableHeader>
      <TableHeader className="w-32">
        
      </TableHeader>
    </TableRow>
    </thead>


  );
}
